const THOUSAND = 1000;
const MILLION = 1_000_000;

/**
 * Compact numeric format for the dashboard saved-filters card: 245 000 → “245 k”,
 * 1 234 567 → “1,2 M”, 983 → “983”. Locale-aware digits come from the caller.
 */
export function formatCompactNumber(
  value: number,
  formatNumber: (value: number, decimals?: number) => string | null
): string {
  const abs = Math.abs(value);
  if (abs >= MILLION) {
    const millions = Math.round((value / MILLION) * 10) / 10;
    return `${formatNumber(millions, Number.isInteger(millions) ? 0 : 1) ?? millions} M`;
  }
  if (abs >= THOUSAND) {
    const thousands = Math.round(value / THOUSAND);
    return `${formatNumber(thousands) ?? thousands} k`;
  }
  return formatNumber(value) ?? String(value);
}
